import { useQuery } from '@tanstack/react-query'
import { employeeProjectsQueryOptions, meQueryOptions } from '../api/queries'

// Проекты, где текущий сотрудник закреплён участником — множеством, для фильтра
// «Только мои» на хабе компаний и странице компании.
//
// Оба запроса ходят только под включённым фильтром: выключенная галочка (дефолт)
// не должна стоить странице ни одного запроса. Пока `me` не приехал, второй запрос
// стоять не может — id сотрудника берётся из него.
//
// `ids === null` значит «фильтровать нечем» (галочка снята или данные ещё едут) —
// потребитель в этом случае показывает полный список.
export function useMyProjectIds(enabled: boolean): {
  ids: Set<string> | null
  isPending: boolean
} {
  const meQ = useQuery({ ...meQueryOptions, enabled })
  const meId = meQ.data?.id
  const projectsQ = useQuery({
    ...employeeProjectsQueryOptions(meId ?? ''),
    enabled: enabled && meId !== undefined,
  })

  // При enabled=false запрос стоит в pending c fetchStatus=idle — не ждём его.
  if (!enabled) return { ids: null, isPending: false }

  return {
    ids: projectsQ.data ? new Set(projectsQ.data) : null,
    isPending: meQ.isPending || projectsQ.isPending,
  }
}
